module.exports = __webpack_public_path__ + "static/img/1.5dc58486.jpg";